import { api_GET } from "api/axios.js";

const regional_api =
{
    getAll: function () {
        const promise = new Promise((resolve, reject) => {
            api_GET(`regional`).then(result => {
                resolve(result)
            });
        });

        return promise;
    }
}

export default regional_api
